var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAdditionalcomponents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.052,
    height: 19.059,
    viewBox: "0 0 15.052 19.059",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(-36.183 -759.067)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(30.2 759.067)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M28.235,15.5a.627.627,0,0,0-.032-.184c0-.011-.006-.022-.01-.032a.638.638,0,0,0-.094-.165l-.008-.014L23.7,9.762c-.006-.008-.014-.013-.021-.02a.551.551,0,0,0-.055-.054c-.014-.012-.028-.025-.042-.036a.618.618,0,0,0-.068-.042c-.015-.008-.029-.017-.045-.025a.665.665,0,0,0-.085-.03c-.014,0-.026-.009-.039-.012a.658.658,0,0,0-.13-.014H13.819a.636.636,0,0,0-.636.636V27.952a.636.636,0,0,0,.636.636H27.6a.636.636,0,0,0,.636-.636V15.5Zm-4.394-3.559,2.411,2.932H23.841ZM14.455,27.316V10.8h8.113v4.707a.636.636,0,0,0,.636.636h3.758V27.316Z",
    transform: "translate(-7.2 -9.529)",
    fill: "#005e98"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    "data-name": "Line 44",
    y2: 7,
    transform: "translate(43.5 766.477)",
    fill: "none",
    stroke: "#005e98",
    strokeLinecap: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_45",
    "data-name": "Line 45",
    y2: 7,
    transform: "translate(47 769.977) rotate(90)",
    fill: "none",
    stroke: "#005e98",
    strokeLinecap: "round",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdditionalcomponents);
export default __webpack_public_path__ + "static/media/Icon-Additional components.cc4b114496d910a2c82d58b8681e6d9c.svg";
export { ForwardRef as ReactComponent };